// extracted by mini-css-extract-plugin
module.exports = {"content":"content-module--content--3sEbK","aboutme":"content-module--aboutme--2FIui"};